export default __webpack_public_path__ + "static/media/three-colorways.d6421064.mp4";